import Advice from "components/common/Advice"
import * as S from "./NewsroomAdvice.style"

const NewsroomAdvice = () => {
    const children = (
        <S.Contact>
            <S.ContactTitle variant="headline-03">Assessoria de imprensa</S.ContactTitle>
            <S.ContactEmail href="mailto:imprensa@cnpbrasil.com.br" alt="enviar um e-mail para imprensa@cnpbrasil.com.br">imprensa@cnpbrasil.com.br</S.ContactEmail>
        </S.Contact> 
    )
    return (
        <Advice
            title={"Fale com a nossa assessoria"}
            paragraph={"Para envio de pautas, respostas ao consumidor, solicitações de entrevistas, fotos e outras informações referentes à CNP Seguros Holding Brasil, entre em contato com a nossa assessoria de imprensa."}
            children={children} 
        />
    );
};

export default NewsroomAdvice;